import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => {
  return {
    elementStyle: {
      "& svg": {
        height: "0.7em",
      },
    },
    icons: {
      display: "flex",
      marginLeft: -11,
    },
    radioIcon: {
      opacity: 0,
      position: "absolute",
      width: 40,
      height: 40,
    },
    icon: {
      fontSize: 40,
      cursor: "pointer",
    },
    thumbsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    helperTextRow: {
      fontSize: 12,
      color: "rgba(0, 0, 0, 0.54)",
      maxWidth: 700,
    },
    container: {
      display: "flex",
      justifyContent: "center",
    },
    centerContainer: {
      display: "flex",
      flexDirection: "row",
      width: 164,
      justifyContent: "space-between",
      marginTop: 38,
    },
  };
});

export default useStyles;
